import React from 'react'
import { Updater, fromJSX, Widget } from 'widgets-for-react'
import { CookiebarLayout } from './cookiebarLayout'
import { CookiebarState, cookiebarStateUpdaters } from './cookiebarState'
import { acceptAllCookies, acceptSelectedCookies, denyAllCookies } from '../../utils/datalayer.mapping'

export const cookiebarWidget = (state: CookiebarState): Widget<Updater<CookiebarState>> =>
  fromJSX((setState) =>
    state.visible ? (
      <CookiebarLayout
        onAcceptAll={() => acceptAllCookies()}
        onDeclineAll={() => denyAllCookies()}
        onApplySettings={() => acceptSelectedCookies(state.cookies)}
        onSetSingle={(name, value) =>
          setState(cookiebarStateUpdaters.selectedCookiesUpdater(state.cookies.set(name, value), false))
        }
        showOptions={state.expandOptions}
        toggleOptions={() => setState(cookiebarStateUpdaters.expandOptionsUpdater)}
        selectedCookieValues={state.cookies}
      />
    ) : (
      <> </>
    )
  )
